import z from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalNumber,
  nullSafeOptionalString,
} from '../shared/schema'
import { GradeSyncJobStatus } from './types'
export { GradeSyncJobStatus }

export const schema = z.object({
  sectionId: z.string(),
  assignmentId: z.string(),
  roomStateId: nullSafeOptionalString(),
  targetUserId: nullSafeOptionalString(),
  forceResend: z.boolean(),
  status: z.preprocess(
    (val) => val ?? GradeSyncJobStatus.pending,
    z.nativeEnum(GradeSyncJobStatus)
  ),
  errorMessage: nullSafeOptionalString(),
  rowsProcessed: nullSafeOptionalNumber(),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
  completedAt: nullSafeOptionalFirestoreTimestamp(),
  // Continuation fields for batch processing
  remainingRoomStateIds: z.array(z.string()).optional(),
  continuationId: nullSafeOptionalNumber(),
})

export const empty = Object.freeze(
  schema.parse({
    sectionId: '',
    assignmentId: '',
    forceResend: false,
    status: GradeSyncJobStatus.pending,
    createdAt: { seconds: 0, nanoseconds: 0 },
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreGradeSyncJob extends z.infer<typeof schema> {}
